import { Link } from "react-router-dom";

export default function Blogs() {
  window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <>
        <div className="page-head">
          <div className="container">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Blogs</li>
            </ol>
            <h1>Blogs</h1>
            <p className="text-mono" style={{ color: "#B9C0F0" }}>
              Practical notes on technical analysis, psychology and market
              structure.
            </p>
          </div>
        </div>
        <section className="section">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="blog-card">
                  <img
                    src="assets/website/img/blog-1-1.jpg"
                    alt="My Experience Receiving  "
                    loading="lazy"
                  />
                  <div className="bc-body">
                    <span className="blog-meta">
                      Announcements · Jun 6, 2026
                    </span>
                    <h3>
                      My Experience Receiving the "India's Most Trusted Stock
                      Market Institute" Award
                    </h3>
                    <p className="text-muted-soft small">
                      As Founder, I've always believed recognition should be a
                      natural outcome of good work, not something an institution
                      chases.
                    </p>
                    <Link to="#">Read more →</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="blog-card">
                  <img
                    src="assets/website/img/blog-1-1.jpg"
                    alt="Volume Analysis Confirms Price Movements"
                    loading="lazy"
                  />
                  <div className="bc-body">
                    <span className="blog-meta">Info · Mar 13, 2026</span>
                    <h3>Volume Analysis Confirms Price Movements</h3>
                    <p className="text-muted-soft small">
                      Understanding price movement without analysing the volume
                      behind it is like navigating with half a map.
                    </p>
                    <Link to="#">Read more →</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="blog-card">
                  <img
                    src="assets/website/img/blog-1-1.jpg"
                    alt="Fibonacci Retracement Levels Predict Price Reversals"
                    loading="lazy"
                  />
                  <div className="bc-body">
                    <span className="blog-meta">Info · Mar 13, 2026</span>
                    <h3>
                      Fibonacci Retracement Levels Predict Price Reversals
                    </h3>
                    <p className="text-muted-soft small">
                      Fibonacci levels are among the most debated tools in
                      technical trading — near-magical to some, overhyped to
                      others.
                    </p>
                    <Link to="#">Read more →</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="blog-card">
                  <img
                    src="assets/website/img/blog-1-1.jpg"
                    alt="How to Build & Master Trading Psychology"
                    loading="lazy"
                  />
                  <div className="bc-body">
                    <span className="blog-meta">How Tos · Mar 13, 2026</span>
                    <h3>How to Build &amp; Master Trading Psychology</h3>
                    <p className="text-muted-soft small">
                      Even traders who win more often than they lose can still
                      end up unprofitable — psychology decides the rest.
                    </p>
                    <Link to="#">Read more →</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="blog-card">
                  <img
                    src="assets/website/img/blog-1-1.jpg"
                    alt="Market Trend Identification — 5 Methods for Direction Analysis"
                    loading="lazy"
                  />
                  <div className="bc-body">
                    <span className="blog-meta">Info · Feb 18, 2026</span>
                    <h3>
                      Market Trend Identification — 5 Methods for Direction
                      Analysis
                    </h3>
                    <p className="text-muted-soft small">
                      Consistently identifying market trends isn't a
                      nice-to-have edge — it's a non-negotiable foundation.
                    </p>
                    <Link to="#">Read more →</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="blog-card">
                  <img
                    src="assets/website/img/blog-1-1.jpg"
                    alt="Chart Patterns Indicate Price Direction — 12 Reliable Formations"
                    loading="lazy"
                  />
                  <div className="bc-body">
                    <span className="blog-meta">Info · Feb 18, 2026</span>
                    <h3>
                      Chart Patterns Indicate Price Direction — 12 Reliable
                      Formations
                    </h3>
                    <p className="text-muted-soft small">
                      Learning to read chart patterns is one of the most
                      critical skills for traders at any level.
                    </p>
                    <Link to="#">Read more →</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="blog-card">
                  <img
                    src="assets/website/img/blog-1-1.jpg"
                    alt="RSI, MACD & Moving Averages — Complete Usage Guide"
                    loading="lazy"
                  />
                  <div className="bc-body">
                    <span className="blog-meta">Info · Feb 18, 2026</span>
                    <h3>
                      RSI, MACD &amp; Moving Averages — Complete Usage Guide
                    </h3>
                    <p className="text-muted-soft small">
                      Indicators can feel like mysterious code until you
                      understand their real utility on a live chart.
                    </p>
                    <Link to="#">Read more →</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="blog-card">
                  <img
                    src="assets/website/img/blog-1-1.jpg"
                    alt="Support & Resistance in Trading — How to Read Price Action"
                    loading="lazy"
                  />
                  <div className="bc-body">
                    <span className="blog-meta">Info · Feb 18, 2026</span>
                    <h3>
                      Support &amp; Resistance in Trading — How to Read Price
                      Action
                    </h3>
                    <p className="text-muted-soft small">
                      Support and resistance zones represent the invisible
                      boundaries every price chart respects.
                    </p>
                    <Link to="#">Read more →</Link>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="blog-card">
                  <img
                    src="assets/website/img/blog-1-1.jpg"
                    alt="20 Most Profitable Candlestick Formations Explained"
                    loading="lazy"
                  />
                  <div className="bc-body">
                    <span className="blog-meta">Info · Nov 20, 2025</span>
                    <h3>20 Most Profitable Candlestick Formations Explained</h3>
                    <p className="text-muted-soft small">
                      Trading often feels like navigating a sea of conflicting
                      signals — candlestick patterns cut through the noise.
                    </p>
                    <Link to="#">Read more →</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
}
